var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V2.01562H2.01562V6H12ZM6.89062 15.0938C7.48438 15.6875 8.1875 15.9844 9 15.9844C9.8125 15.9844 10.5156 15.6875 11.1094 15.0938C11.7031 14.5 12 13.7969 12 12.9844C12 12.1719 11.7031 11.4688 11.1094 10.875C10.5156 10.2812 9.8125 9.98438 9 9.98438C8.1875 9.98438 7.48438 10.2812 6.89062 10.875C6.29688 11.4688 6 12.1719 6 12.9844C6 13.7969 6.29688 14.5 6.89062 15.0938ZM14.0156 0L18 3.98438V15.9844C18 16.5156 17.7969 16.9844 17.3906 17.3906C16.9844 17.7969 16.5156 18 15.9844 18H2.01562C1.45312 18 0.96875 17.8125 0.5625 17.4375C0.1875 17.0312 0 16.5469 0 15.9844V2.01562C0 1.45312 0.1875 0.984375 0.5625 0.609375C0.96875 0.203125 1.45312 0 2.01562 0H14.0156Z",
    fill: "#006596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.bba7172b4a8365cfea0eda1c8c16a690.svg";
export { ForwardRef as ReactComponent };